import React from "react";
import Header from '../header/Header';
import HeaderSecondary from '../header/HeaderSecondary';

export default function Navbar(props) {
  const [scroll, setScroll] = React.useState(0);

  const handleScroll = () => setScroll(document.documentElement.scrollTop);

  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const className = scroll > 80 ? "fixed-navbar active scrolled" : "fixed-navbar";
  
  // Use secondary header for non-home pages
  const HeaderComponent = props.isSecondary ? HeaderSecondary : Header;

  return (
    <div className={className}>
      <HeaderComponent 
        hclass={props.hclass} 
        Logo={props.Logo} 
        topbarClass={props.topbarClass}
        isScrolled={scroll > 80}
      />
    </div>
  );
}